<template>
	<dialog
		v-show="open"
		:open="open"
		ref="inlineModal"
		class="full absolute top-0 left-0 z-60 flex h-full w-full items-center justify-center bg-black/50"
	>
		<div
			class="inline-modal-backdrop absolute inset-0 bg-center bg-no-repeat"
			@click="emit('update:open', false)"
		></div>
		<div
			class="relative flex flex-col overflow-y-auto rounded-lg bg-white px-6 py-10"
			:class="{
				'h-full w-full': variant === 'large',
				'w-[400px]': variant === 'small',
			}"
		>
			<slot name="header">
				<div class="mb-4 flex w-full items-center justify-between gap-3">
					{{ header }}
					<button
						type="button"
						@click="emit('update:open', false)"
					>
						<XMarkIcon class="size-6" />
					</button>
				</div>
			</slot>
			<div class="grow overflow-y-auto">
				<slot></slot>
			</div>
		</div>
	</dialog>
</template>

<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/solid'
import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue'

withDefaults(
	defineProps<{
		header?: string
		variant?: 'large' | 'small' | 'adaptive'
	}>(),
	{
		variant: 'large',
	}
)

const open = defineModel<boolean>('open')
const inlineModal = ref<HTMLDialogElement | null>(null)

const emit = defineEmits<{
	(e: 'update:open', value: boolean): void
}>()

onClickOutside(inlineModal, () => {
	emit('update:open', false)
})
</script>
